import { render, staticRenderFns } from "./addreduction.vue?vue&type=template&id=6206e7f1&scoped=true&"
import script from "./addreduction.vue?vue&type=script&lang=js&"
export * from "./addreduction.vue?vue&type=script&lang=js&"
import style0 from "./addreduction.vue?vue&type=style&index=0&id=6206e7f1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6206e7f1",
  null
  
)

export default component.exports